import { SET_STEP_INDEX, SET_USER_VALID } from '../actions/actionTypes';

const initialState = {
  stepIndex: 1,
  userValid: false
};

export const stepperReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STEP_INDEX:
      return {
        ...state,
        stepIndex: action.newValue
      };      

    case SET_USER_VALID:
      return {
        ...state,
        userValid: action.newValue
      };      

    default:
      return state;
  }
};
